import React from 'react'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import BugsnagPerformance from '@bugsnag/browser-performance'

const apiKey = process.env.RAZZLE_BUGSNAG_API_KEY

const PassThroughBoundary = ({ children }: { children?: React.ReactNode }) =>
  React.createElement(React.Fragment, null, children)

export const BugsnagInstance = apiKey
  ? Bugsnag.start({
      apiKey,
      releaseStage: process.env.RAZZLE_BUGSNAG_RELEASE_STAGE,
      plugins: [new BugsnagPluginReact()],
    })
  : undefined

export const BugsnagPerformanceInstance = apiKey ? BugsnagPerformance.start({ apiKey }) : undefined

export const BugsnagErrorBoundary = BugsnagInstance
  ? (Bugsnag.getPlugin('react')?.createErrorBoundary(React) ?? PassThroughBoundary)
  : PassThroughBoundary
